import { SEARCH_LABEL_COOKIE, toSearchSlug } from '@/lib/search-url';

const COOKIE_MAX_AGE = 600;
const RECENT_SEARCHES_KEY = 'haber-recent-searches';
const RECENT_SEARCHES_MAX = 6;

export function saveSearchLabel(query: string): void {
  const trimmed = query.trim();
  if (trimmed.length < 2) return;

  document.cookie = `${SEARCH_LABEL_COOKIE}=${encodeURIComponent(trimmed)}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  pushRecentSearch(trimmed);
}

export function readSearchLabel(slug: string): string | null {
  if (typeof document === 'undefined' || !slug) return null;

  const match = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${SEARCH_LABEL_COOKIE}=`));

  if (!match) return null;

  const label = decodeURIComponent(match.slice(SEARCH_LABEL_COOKIE.length + 1)).trim();
  if (!label || toSearchSlug(label) !== slug) return null;

  return label;
}

export function getRecentSearches(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(RECENT_SEARCHES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((x): x is string => typeof x === 'string')
      .map((x) => x.trim())
      .filter((x) => x.length >= 2)
      .slice(0, RECENT_SEARCHES_MAX);
  } catch {
    return [];
  }
}

export function pushRecentSearch(query: string): void {
  if (typeof window === 'undefined') return;
  const trimmed = query.trim();
  if (trimmed.length < 2) return;
  try {
    const prev = getRecentSearches().filter(
      (q) => q.toLocaleLowerCase('tr-TR') !== trimmed.toLocaleLowerCase('tr-TR'),
    );
    localStorage.setItem(
      RECENT_SEARCHES_KEY,
      JSON.stringify([trimmed, ...prev].slice(0, RECENT_SEARCHES_MAX)),
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearRecentSearches(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch {
    /* ignore */
  }
}
